import { BaseModel } from './base.model'
import { CenterProgram } from './center-program.model'
import { Program } from './program.model'

export class AccessCondition extends BaseModel<AccessCondition> {
  static DEFAULT_ATTRIBUTES = {}

  centerProgram: CenterProgram
  id: number
  grade: number
  program: Program
  course: string
  _destroy: boolean

  get programId(): number|null {
    return this.program ? this.program.id : null
  }

  get centerProgramId(): number|null {
    return this.centerProgram ? this.centerProgram.id : null
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/access-condition.model.ts